import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {BasePayloadSchema} from './base-payload'

const WhitepaperContentTypes = z.lazy(() => z.enum(['whitepaper', 'ebook']))
const WhitepaperCategories = z.lazy(() =>
  z.enum([
    'ai',
    'cloud',
    'devops',
    'github-actions',
    'github-advanced-security',
    'github-enterprise',
    'innersource',
    'open-source',
    'security',
    'software-development',
  ]),
)

/**
 * Payload schema for whitepaper index pages.
 */
export const WhitepaperIndexPayloadSchema = z.lazy(() =>
  BasePayloadSchema.unwrap().extend({
    additionalProps: z.object({
      page: z.number(),
      totalPages: z.number(),
      filters: z.object({
        contentTypes: safeOptional(z.array(WhitepaperContentTypes)),
        topics: safeOptional(z.array(WhitepaperCategories)),
      }),
    }),
  }),
)

export type WhitepaperIndexPayload = z.infer<typeof WhitepaperIndexPayloadSchema>

export function toWhitepaperIndexPayload(payload: unknown): WhitepaperIndexPayload {
  return WhitepaperIndexPayloadSchema.parse(payload)
}
